import { Component, Input } from '@angular/core';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';

@Component({
  selector: 'app-submenu-item',
  templateUrl: './submenu-item.component.html',
  styleUrls: ['./submenu-item.component.scss']
})
export class SubmenuItemComponent {

  @Input() item!: IToolbarItem;
  urlActive!: boolean;


  constructor(public router: Router) { }

  ngOnInit(){
    this.urlActive = false;

  }

  validateUrlActive(){
    return this.urlActive ?? false;
  }

  validateUrl() {
    // Obtener la parte inicial de la ruta del toolbar item
    const itemRouteBase = this.getRouteBase(this.item.route ?? '');
    
    // Obtener la parte inicial de la ruta actual
    const currentRouteBase = this.getRouteBase(this.router.url);
    
    // Comparar si las partes iniciales de las rutas son iguales
    if(currentRouteBase === itemRouteBase){
      this.urlActive = true;

      return true;
    }else{
      return false;
    }
  }
  
  private getRouteBase(route: string): string {
  // Dividir la ruta en segmentos
  const segments = route.split('/');
  
  // Filtrar los segmentos que no son parámetros
  const routeSegments = segments.filter(segment => !segment.match(/^[0-9]+$/)); // Filtrar los segmentos que son números (suponiendo que los parámetros son números)
  
  // Volver a construir la ruta base
  return routeSegments.join('/');
  }

}
